var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.0007C5.63333 12.0007 5.31944 11.8701 5.05833 11.609C4.79722 11.3479 4.66667 11.034 4.66667 10.6673V2.66732C4.66667 2.30065 4.79722 1.98676 5.05833 1.72565C5.31944 1.46454 5.63333 1.33398 6 1.33398H12C12.3667 1.33398 12.6806 1.46454 12.9417 1.72565C13.2028 1.98676 13.3333 2.30065 13.3333 2.66732V10.6673C13.3333 11.034 13.2028 11.3479 12.9417 11.609C12.6806 11.8701 12.3667 12.0007 12 12.0007H6ZM6 10.6673H12V2.66732H6V10.6673ZM3.33333 14.6673C2.96667 14.6673 2.65278 14.5368 2.39167 14.2757C2.13056 14.0145 2 13.7007 2 13.334V4.00065H3.33333V13.334H10.6667V14.6673H3.33333Z",
    fill: "#586C7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsClipboard);
export default __webpack_public_path__ + "static/media/icons_clipboard.7f1890ed.svg";
export { ForwardRef as ReactComponent };